import { useId } from "react";
import { REGISTER_QUANTITY_UNITS } from "@/lib/registerQuantity";
import "./RegisterQuantityField.css";

interface RegisterQuantityInputsProps {
  quantity: string;
  unit: string;
  onQuantityChange: (value: string) => void;
  onUnitChange: (value: string) => void;
  disabled?: boolean;
  quantityErrors?: string[];
  unitErrors?: string[];
}

const unitLabels: Record<(typeof REGISTER_QUANTITY_UNITS)[number], string> = {
  bu: "Bushels", ton: "Tons", cwt: "Hundredweight", lb: "Pounds", piece: "Pieces",
  bag: "Bags", carton: "Cartons", lint_lb: "Lint pounds", head: "Head",
};

/** Shared accessible fields; the row requires a quantity, while the composer makes it optional. */
export function RegisterQuantityInputs({ quantity, unit, onQuantityChange, onUnitChange,
  disabled, quantityErrors, unitErrors }: RegisterQuantityInputsProps) {
  const id = useId();
  return (
    <div className="register-quantity__inputs">
      <div className="register-quantity__field">
        <label htmlFor={`${id}-quantity`}>Quantity</label>
        <input id={`${id}-quantity`} type="text" inputMode="decimal" value={quantity}
          disabled={disabled} onChange={(e) => onQuantityChange(e.target.value)}
          aria-invalid={quantityErrors?.length ? true : undefined}
          aria-describedby={quantityErrors?.length ? `${id}-quantity-error` : undefined} />
        {quantityErrors?.length ? <span id={`${id}-quantity-error`} role="alert"
          className="register-quantity__error">{quantityErrors.join(" ")}</span> : null}
      </div>
      <div className="register-quantity__field">
        <label htmlFor={`${id}-unit`}>Unit</label>
        <select id={`${id}-unit`} value={unit} disabled={disabled}
          onChange={(e) => onUnitChange(e.target.value)}
          aria-invalid={unitErrors?.length ? true : undefined}
          aria-describedby={unitErrors?.length ? `${id}-unit-error` : undefined}>
          <option value="">Choose a unit</option>
          {REGISTER_QUANTITY_UNITS.map((value) => <option key={value} value={value}>{unitLabels[value]}</option>)}
        </select>
        {unitErrors?.length ? <span id={`${id}-unit-error`} role="alert"
          className="register-quantity__error">{unitErrors.join(" ")}</span> : null}
      </div>
    </div>
  );
}
